import React, {PureComponent} from 'react'
import './News.css'

class News1 extends PureComponent {
	render() {
		return (
			<div style={{maxWidth: '667px', margin: 'auto'}}>
				<div>
					<h2 style={{fontSize: '22px', lineHeight: 1.4}}>
						新门店时代！如何装点门店吸引更多顾客进门消费？
					</h2>
					<section style={{
						letterSpacing: '0px',
						paddingRight: '6px',
						paddingLeft: '6px',
						fontSize: '16px',
						lineHeight: 2,
						boxSizing: 'border-box'
					}}>
						<section>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;门店最宝贵的资产，不是店面的大小，豪华的装修，而是门店门前熙熙攘攘的路人——门前路过的行人越多，进店的可能性越大，这也是为什么门店愿意开在人群最密集的地方之一。而进店的路人越多，转化为购买行为的概率也越大。
							</div>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.1.webp"/>
						</section>
						<section>
							<div className='text-center' style={{fontSize: '12px'}}>
								北京著名餐馆胡大小龙虾外等候吃饭的人群
							</div>
						</section>
						<section>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;销售中有一个平均法则也适用于门店：<strong>门店销售额与门店的顾客数量成正比关系。顾客越多，销售额就越高。</strong>
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;门店的老板们肯定都思考过一个问题：每天有熙熙攘攘的人流从我的店门前路过，如何让他们为什么进店看看？我该如何吸引顾客进店呢？
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;别急，我们先来复盘一下绝味鸭脖在京东总部的路演。
							</div>
							<div style={{fontSize: '14px'}}>
								<a
									href={'https://mp.weixin.qq.com/s/nQay455bDeL011w6XaTrfQ'}>https://mp.weixin.qq.com/s/nQay455bDeL011w6XaTrfQ</a>（京东路演实况记录链接。）
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;先来一波图。
							</div>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.2.webp"/>
						</section>
						<section>
							<div className='text-center' style={{fontSize: '12px'}}>
								大家围着屏幕
							</div>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.3.webp"/>
						</section>
						<section>
							<div className='text-center' style={{fontSize: '12px'}}>
								大家在听工作人员介绍玩法
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;在路演的2天3个小时之间，绝味鸭脖卖出产品近<strong>1000份</strong>，这个数量是相同时间内北京门店平均销售量的<strong>2倍</strong>；其中跳一跳小游戏参与人数679人，参与游戏共计5428次。
							</div>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.4.webp"/>
						</section>
						<section>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;值得一提的是，第一天在跳一跳小游戏中获得最高分118分的ID用户，今天<strong>再次</strong>来到店里吃鸭脖刷记录，将自己成绩刷新到了122分——这个成绩也是目前游戏最高分。
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;美未大数据实验室发现，此次路演活动中，有<strong>40%</strong>的小游戏参与ID在两天的数据中<strong>同时出现</strong>。
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;<strong>这个数据也佐证了门店引流屏对提高用户粘性的重要性。</strong>
							</div>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.5.webp"/>
						</section>
						<section>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;<strong>门店的形象可以卖钱——这是写在营销书上的铁律。</strong>
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;一个大大的黄色M，顾客从很远的地方都可以知道那是麦当劳。门店想提高自己的辨识度从而提高对路人的吸引力，必须要下一番功夫。这其中，媒体宣传是常见的一种形式。
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;可是媒体太贵。打广告也太贵。
							</div>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.6.webp"/>
						</section>
						<section>
							<div className='text-center' style={{fontSize: '12px'}}>
								著名网红奶茶店喜茶的营销花了血本
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;<strong>因此，美未智能屏想让每个门店都成为“为自己代言的媒体”。</strong>充分利用音、像、图、字、色等元素，将信息有效地传播，以达到宣传效果，影响行人，以吸引顾客进店消费。
							</div>
							<br/>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;继续说绝味的路演。
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;通过大数据实验室的监控与分析，活动期间，90%过路行人的目光成功被吸引到了门店本身，其中<strong>82%</strong>的行人通过步履放缓、停留驻足等方式<strong>主观增加</strong>了在门店屏幕前的逗留率。在逗留在橱窗前的路人中，<strong>70%</strong>的路人将观望、互动状态转化为了<strong>购买行为</strong>。
							</div>
							<br/>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;不仅如此，美未大数据实验室还利用后台数据，将参与屏幕互动的顾客通过大数据画像，将产生购买行为的顾客群体的主要特征，反馈给了绝味，以方便更了解自己的顾客群。
							</div>
							<br/>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.7.webp"/>
						</section>
						<section>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;酒香也怕巷子深，宣传是营销中重要的一环。也许你的门店和店员在某一方面只比竞争对手差那么一点点，但也就是这可怕的"一点点"，却严重影响了门店的销售业绩。
							</div>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.8.webp"/>
						</section>
						<section>
							<div className='text-center' style={{fontSize: '12px'}}>
								著名网红奶茶店喜茶的营销花了血本
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;所以，在区域市场内，要想尽一切办法，让你的门店店名，或是品牌广告语或是符号标志无处不在。记住，还要<strong>持续不断</strong>的做这件事。
							</div>
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;美未智能屏致力于帮助门店向顾客展现出最闪闪亮的自己——通过自身掌握研发的技术将门店最好的形象挖掘展现，帮助门店留住老客、吸引新客。
							</div>
							<br/>
						</section>
						<section style={{marginTop: '10px', marginBottom: '10px'}}>
							<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.9.webp"/>
						</section>
						<section>
							<div className='text-center' style={{fontSize: '12px'}}>
								美未智能屏覆盖点位图
							</div>
						</section>
					</section>
				</div>
			</div>
		)
	}
}

export default News1


// WEBPACK FOOTER //
// ./src/News2.js